export default function translate(i18n, propriete) {
  if (propriete === 'INSEE') return i18n.t('patrimoine.error.codeGenerationProperties.inseeCode');
  if (propriete === 'CODE_POSTAL') return i18n.t('patrimoine.error.codeGenerationProperties.zipCode');
  if (propriete === 'CODIFICATION_DISPOSITIF') return i18n.t('patrimoine.error.codeGenerationProperties.dispositifType');
  if (propriete === 'VISIBILITE') return i18n.t('patrimoine.error.codeGenerationProperties.visibilite');
  if (propriete === 'DISPOSITION') return i18n.t('patrimoine.error.codeGenerationProperties.disposition');

  return propriete;
}
